import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import Navbar from '../../components/Navbar'
import SmallFooter from '../../components/SmallFooter'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Profile = () => {

    const [data, setData] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(false)
    const [isOpen, setIsOpen] = React.useState(false)
    const [bname, setBname] = React.useState('')
    const [pan, setPan] = React.useState('')
    const [gst, setGst] = React.useState('')

    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });

    const reset = () => {
        setBname('')
        setPan('')
        setGst('')
    }

    const validate = () => {
        if (bname === '' || pan === '' || gst === '') {
            notify('Please fill all the fields')
            return false
        }
        if (!bname.match(/^[a-zA-Z ]+$/)) {
            notify('Business Name must contain only letters')
            return false
        }
        if (!gst.match(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[A-Z0-9]{1}$/)) {
            notify('Please enter a valid GST number')
            return false
        }

        if (!pan.match(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)) {
            notify('Please enter a valid PAN number')
            return false
        }
        return true
    }

    const handleUpdate = () => {
        if(validate())
        fetch(process.env.REACT_APP_SERVER_URL + '/seller/updateProfile', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify({
                bname: bname,
                pan: pan,
                gst: gst,
            })
        })

            .then(res => res.json())
            .then(res => {
                if (res.success) {
                    notify(res.message)
                    loadSellerData()
                    setIsOpen(false)
                }
                else {
                    notify(res.message)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }


    const loadSellerData = () => {
        fetch(process.env.REACT_APP_SERVER_URL + '/seller/isloggedin', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        })
            .then(res => res.json())
            .then(res => {
                console.log(res)
                setData(res.seller)
                setIsLoading(false)
            })
            .catch(err => console.log(err))
    }

    React.useEffect(() => {
        setIsLoading(true)
        loadSellerData()
    }, [])

    return (
        <div className='dark:bg-black dark:text-white min-h-screen'>
            <Navbar />
            <div>
                <ToastContainer className='mt-20' />
            </div> {
                isLoading ?
                    null
                    :
                    <div className="relative dark:bg-black  shadow dark:shadow-gray-400 sm:rounded-lg lg:mx-32 mt-2">
                        <div className="px-4 py-5 sm:px-6">
                            <h3 className="text-lg dark:bg-black  font-medium leading-6 dark:text-white text-gray-900">Applicant Information</h3>
                            <p className="mt-1 max-w-2xl text-sm  text-gray-500 dark:bg-black dark:text-gray-400">Personal details and application.</p>
                        </div>
                        <div className="border-t border-gray-200 dark:bg-black dark:border-gray-400 ">
                            <dl>
                                <div className=" bg-white px-4 py-5 dark:bg-black dark:text-white sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        Name
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        {data.name}
                                    </dd>
                                </div>
                                <div className="dark:bg-black bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        Username
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        {data.username}
                                    </dd>
                                </div>
                                <div className="dark:bg-black bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        Email
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        {data.email}
                                    </dd>
                                </div>
                                <div className="dark:bg-black bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        Business Name
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        {data.bname}
                                    </dd>
                                </div>
                                <div className="dark:bg-black bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        PAN
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        {data.pan}
                                    </dd>
                                </div>
                                <div className="dark:bg-black bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        GST Number
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        {data.gst}
                                    </dd>
                                </div>
                                <div className="dark:bg-black bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        Password
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        *********
                                    </dd>
                                </div>
                            </dl>
                            <div className="dark:bg-black bg-white px-4 py-5 grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="text-sm font-medium dark:text-white text-gray-500"></dt>
                                <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:col-span-2 sm:mt-0 space-x-10">
                                    <button className="bg-blue-400 hover:bg-blue-500 text-white font-bold py-2 px-4 rounded"
                                   onClick={(e) => { e.preventDefault(); setIsOpen(true); console.log('clicked'); }}>
                                    
                                        Edit Information
                                    </button>
                                    {/* <button className="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 rounded">
                                        Delete Account
                                    </button> */}
                                </dd>
                            </div>
                        </div>
                    </div>
            }

            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => { setIsOpen(false); reset() }}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl dark:bg-black bg-white p-6 text-left align-middle shadow-xl transition-all dark:shadow-gray-700">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 dark:text-white text-gray-900 flex items-center gap-7"
                                    >

                                        <span>Edit Information</span>
                                    </Dialog.Title>
                                    {<form className="mt-4 space-y-4 lg:mt-5 md:space-y-5" action="#">
                                        <div>
                                            <label htmlFor="banme" className="block text-sm font-medium dark:text-white text-gray-700">Business Name </label>
                                            <div className="mt-1"><input id="banme" type="text" data-testid="username" required="" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" defaultValue={bname} onChange={(e) => setBname(e.target.value)} /></div>

                                        </div>
                                        <div>
                                            <label htmlFor="email" className="block text-sm font-medium dark:text-white text-gray-700">GST Number </label>
                                            <div className="mt-1"><input id="email" type="text" data-testid="username" required="" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" defaultValue={gst} onChange={(e) => setGst(e.target.value)} /></div>
                                        </div>

                                        <div>
                                            <label htmlFor="email" className="block text-sm font-medium dark:text-white text-gray-700">PAN Number </label>
                                            <div className="mt-1"><input id="email" type="text" data-testid="username" required="" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" defaultValue={pan} onChange={(e) => setPan(e.target.value) } /></div>
                                        </div>
                                     

                                        <div>
                                            <button data-testid="login" type="submit" className="group relative flex w-full justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:cursor-wait disabled:opacity-50"
                                            onClick={(e) => { e.preventDefault(); handleUpdate() }}>
                                                Update Profile
                                            </button>
                                        </div>
                                    </form>}

                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>

            <div className='mt-3 w-full'>
                <SmallFooter />
            </div>
        </div>
    )
}

export default Profile